var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-subitem"},[_c('a',{staticClass:"sidebar-subitem_link pl-4 py-1 pr-2",attrs:{"href":_vm.item.href},on:{"click":function (e) { return _vm.onClick(e, _vm.item.href); }}},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }